import { render, staticRenderFns } from "./InformationBreadcrumb.vue?vue&type=template&id=4acbf895&scoped=true&lang=html&"
import script from "./InformationBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./InformationBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./InformationBreadcrumb.vue?vue&type=style&index=0&id=4acbf895&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acbf895",
  null
  
)

export default component.exports